// extracted by mini-css-extract-plugin
export default {"header":"HeaderTitle_header__qznjH","header_sub_container":"HeaderTitle_header_sub_container__QhDdP","tab":"HeaderTitle_tab__qZMYi","text":"HeaderTitle_text__b+dUa"};